export default __webpack_public_path__ + "static/media/developer.d1fc0c14.svg";